import { Event } from "Global/Base/Events";
import { GlobalContext } from "Global/Base/GlobalContext";
import { setupBem } from "Global/Dom/bem";
import { registerCustomElement } from "UI/UI.ElementarControls/Utils/CustomElementUtils";
import { IFormGroup } from "../UI/FormManager/IFormGroup";

const className = setupBem("form-group-container");

/**
 * Třída obsahující skupinu formulářů.
 */
export class FormGroupContainer extends HTMLElement {
    private _formName: string;
    private _id: string;
    private _formGroup: IFormGroup;
    private _isHomePage: boolean = false;

    public readonly visibilityChange: Event<FormGroupContainer, boolean> = new Event;

    public get visible(): boolean {
        return !this.classList.contains(className.modifier("hidden")) && !this.classList.contains(className.modifier("initially-hidden"));
    }
    public set visible(v: boolean) {
        if (!this.classList.contains(className.modifier("hidden"))
            && !this.classList.contains(className.modifier("initially-hidden")) == v) return;

        this.classList.toggle(className.modifier("hidden"), !v);

        if (v)
            this.classList.remove(className.modifier("initially-hidden"));

        this.visibilityChange.trigger(this, v);
    }

    public get formName(): string {
        return this._formName;
    }
    public set formName(v: string) {
        this._formName = v; this.setAttribute("data-form", v);
    }

    public get formGroup(): IFormGroup {
        return this._formGroup;
    }
    public set formGroup(v: IFormGroup) {
        this._formGroup = v;
    }

    public get isHomePage(): boolean {
        return this._isHomePage;
    }
    public set isHomePage(v: boolean) {
        this._isHomePage = v; this.classList.toggle(className.modifier("homepage"), !v);
    }

    public get formId(): string {
        return this._id;
    }
    public set formId(v: string) {
        this._id = v; this.setAttribute("data-form-id", v);
    }

    constructor(self?: any) {
        super();
        self ? self._constructor() : this._constructor(); // polyfill
    }

    protected _constructor(): void {
        this.classList.add(className());
        this.classList.add(className.modifier("initially-hidden"));
    }
}

registerCustomElement("tsc-formgroupcontainer", FormGroupContainer);
GlobalContext.registerType(FormGroupContainer);
